import Method from "@/components/Method";
import Coach from "@/components/home/Coach";
import Manifesto from "@/components/home/Manifesto";
import FinalCTA from "@/components/FinalCTA";
import { Eyebrow, FadeIn, PageHero, usePageMeta } from "@/components/blocks";

const VALUES = [
  { n: "01", title: "Evidence over hype", copy: "Programming decisions come from assessment and progression — never trends." },
  { n: "02", title: "Recovery is training", copy: "We don’t separate recovery from performance. We build both, deliberately." },
  { n: "03", title: "One standard, anywhere", copy: "The same coaching standard whether a client trains in Mumbai, Dubai or New York." },
  { n: "04", title: "Built for the long term", copy: "We coach the body you’ll need in ten years, not just the next ten weeks." },
];

export default function About() {
  usePageMeta(
    "About | StrengthLeap — Human Performance",
    "StrengthLeap is a human performance and coaching company. Recovery, strength, endurance and longevity delivered through one coaching system."
  );

  return (
    <main>
      <PageHero
        testid="about-page"
        eyebrow="About StrengthLeap"
        lines={["A human performance", "company."]}
        copy="Not a personal training service. Not an app. A coaching system that takes people from pain to performance — and keeps them there."
      />

      <Manifesto />

      <section className="bg-bone px-6 pb-28 text-ink sm:px-10 lg:px-16">
        <div className="mx-auto max-w-[1440px]">
          <FadeIn>
            <Eyebrow tone="ink">Operating Principles</Eyebrow>
          </FadeIn>
          <div className="mt-12 grid gap-px border border-ink/15 bg-ink/15 sm:grid-cols-2">
            {VALUES.map((v, i) => (
              <FadeIn key={v.n} delay={i * 0.07} className="bg-bone p-8 sm:p-10">
                <p className="font-mono text-xs uppercase tracking-[0.3em] text-ember">
                  {v.n}
                </p>
                <h3 className="mt-5 font-display text-2xl font-black uppercase tracking-tight">{v.title}</h3>
                <p className="mt-4 text-sm leading-relaxed text-smoke sm:text-base">{v.copy}</p>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      <Method />
      <Coach />
      <FinalCTA />
    </main>
  );
}
